<template>
  <h1 align="center" style="font-family: sans-serif; font-weight: bold">
    Vă rog, așteptați...
  </h1>
</template>

<script>
import { CONFIRM_ROLE } from "@/api.js";

export default {
  created() {
    const token = this.$route.params.pathMatch;

    const error = (msg) => {
      this.$toastr.e(`${msg}` || "Activarea rolului a eșuat.");
      this.goToHomePage();
    };

    CONFIRM_ROLE(token)
      .then((res) => {
        const resCode = res?.meta?.HttpStatusCode || res.statusCode;

        if (this.checkHttpStatusCode(resCode)) {
          this.$toastr.s(
            "Rolul a fost activat. Va trebui să te reautentifici pentru a vedea rolul.",
          );

          this.logout();
        } else if (resCode === 401) {
          error("Trebuie să fii autentificat pentru a confirma rolul.");
        } else {
          error(res?.response || res?.meta?.message);
        }
      })
      .catch(error);
  },
};
</script>
